export default __webpack_public_path__ + "static/media/management-products-fill-icon.5b8cab54.svg";